import { useState, useEffect } from "react";
import { Detailprops, DATA_DETAIL, ajax_get, get_detail } from "Data/detail";
import { useLoading } from "../Provider/AppProvider";


const useDetailData = (id: string | null) => {
	const [data, setData] = useState<Detailprops>();
	const { setLoading } = useLoading();

	useEffect(() => {
		const get = () => {
			if (id !== null) {
				setLoading(true);
				ajax_get('http://project42.abclab.kr/admin/index.php/wp-json/wp/v2/zplanet/?per_page=100', (res: any) => {
					setData(get_detail(res[parseInt(id)], id));
					setLoading(false);
				});
			}
		};
		get();
	}, [id]);
	return { data };
};

export default useDetailData;
